import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { $qs } from "../utils/QuerySelector";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);



const onScroll = () => {  


  // Animate image - rotate to left
  if ( $qs('.animate-image--left') !== null  ) {
    const animateImageLeft = gsap.timeline({
      paused: false,
    });  
    animateImageLeft.fromTo( '.animate-image--left img',
      {
        rotate: -3,
      },
      {
        rotate: -6,
        ease: "none",
      },
    )
    ScrollTrigger.create({
      trigger: ".animate-image--left",
      start: 'top 40%',
      end: 'bottom top',
      scrub: 0.3,
      animation: animateImageLeft
    })
  }

  // Animate image - rotate to right
  if ( $qs('.animate-image--right') !== null  ) {
    const animateImageRight = gsap.timeline({
      paused: false,
    });  
    animateImageRight.fromTo( '.animate-image--right img',
      {
        rotate: 3,
      },
      {
        rotate: 6,
        ease: "none",
      },
    )
    ScrollTrigger.create({
      trigger: ".animate-image--right",
      start: 'top top',
      end: 'bottom top',
      scrub: 0.3,
      animation: animateImageRight
    })
  }



  // Animate image - rotate to left
  if ( $qs('.animate-image--left') !== null  ) {
    const animateImgLeft = gsap.timeline({
      paused: false,
    });  
    animateImgLeft.fromTo( '.animate-img--left',
      {
        rotate: -4,
      },
      {
        rotate: -7,
        ease: "none",
      },
    )
    ScrollTrigger.create({
      trigger: ".animate-img--left",
      start: 'top 40%',
      end: 'bottom top',
      scrub: 0.3,
      animation: animateImgLeft
    })
  }

  // Animate image - rotate to right
  if ( $qs('.animate-img--right') !== null  ) {
    const animateImgRight = gsap.timeline({
      paused: false,
    });  
    animateImgRight.fromTo( '.animate-img--right',
      {
        rotate: 4,
      },
      {
        rotate: 7,
        ease: "none",
      },
    )
    ScrollTrigger.create({
      trigger: ".animate-img--right",
      start: 'top top',
      end: 'bottom top',
      scrub: 0.3,
      animation: animateImgRight
    })
  }

};

  




export default onScroll;
